var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { AuthButton, Form, InputField, InputLink, useAuth } from "peggirkit";
import PasswordField from "../../../Input/PasswordField";
import AuthFormSignInTotp from "./AuthFormSignInTotp";
var AuthFormSignIn = function (_a) {
    var forgotPasswordUrl = _a.forgotPasswordUrl;
    var intl = useIntl();
    var _b = useForm(), register = _b.register, getValues = _b.getValues, handleSubmit = _b.handleSubmit, errors = _b.formState.errors;
    var _c = useForm(), registerTotp = _c.register, getValuesTotp = _c.getValues, handleSubmitTotp = _c.handleSubmit, setValueTotp = _c.setValue, resetTotp = _c.reset, errorsTotp = _c.formState.errors;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(null), formError = _e[0], setFormError = _e[1];
    var _f = useState(false), totpLoading = _f[0], setTotpLoading = _f[1];
    var _g = useState(false), showTotpModal = _g[0], setShowTotpModal = _g[1];
    var _h = useState(false), showSessionExpiredModal = _h[0], setShowSessionExpiredModal = _h[1];
    var _j = useState(null), totpFormError = _j[0], setTotpFormError = _j[1];
    var authContext = useAuth();
    var cancelTotp = function () {
        setLoading(false);
        setTotpFormError(null);
        setShowTotpModal(false);
        setTotpLoading(false);
        resetTotp();
    };
    useEffect(function () {
        if (!loading) {
            return;
        }
        var submittedData = getValues();
        authContext === null || authContext === void 0 ? void 0 : authContext.onSignIn(submittedData.emailAddress, submittedData.password).catch(function (e) {
            if (e && e.statusCode && e.statusCode === 202) {
                setValueTotp("mfaRequestToken", e.mfaRequestToken.message);
                setShowTotpModal(true);
            }
            else {
                setLoading(false);
                setFormError(intl.formatMessage({ id: "invalidEmailOrPassword" }));
            }
        });
    }, [loading]);
    useEffect(function () {
        if (!totpLoading) {
            return;
        }
        var submittedSignInData = getValues();
        var submittedTotpData = getValuesTotp();
        authContext === null || authContext === void 0 ? void 0 : authContext.onSignInTotp(submittedSignInData.emailAddress, submittedSignInData.password, submittedTotpData.totp, submittedTotpData.mfaRequestToken).catch(function (e) {
            if (e && e.response && e.response.status && e.response.status === 408) {
                cancelTotp();
                setShowSessionExpiredModal(true);
            }
            else {
                setTotpLoading(false);
                setTotpFormError(intl.formatMessage({ id: "entered2FaCodeWrong" }));
            }
        });
    }, [totpLoading]);
    return (_jsxs(_Fragment, { children: [_jsxs(Form, __assign({ onSubmit: handleSubmit(function () { return setLoading(true); }), error: formError }, { children: [_jsx(InputField, { id: "emailAddress", displayName: intl.formatMessage({ id: "emailAddress" }), type: "email", placeholder: intl.formatMessage({ id: "emailAddress.placeholder" }), disabled: loading, error: errors.emailAddress && errors.emailAddress.message, reactHookForm: __assign({}, register("emailAddress", {
                            required: intl.formatMessage({ id: "enterEmailAddress" }),
                            minLength: {
                                value: 3,
                                message: intl.formatMessage({ id: "mustContainAtLeastCharacters" }, { min: 3 })
                            },
                            maxLength: {
                                value: 128,
                                message: intl.formatMessage({ id: "canContainAtMostCharacters" }, { max: 128 })
                            }
                        })) }), _jsx(PasswordField, { fieldName: "password", displayName: intl.formatMessage({ id: "password" }), register: register, disabled: loading, fieldError: errors.password }), _jsx(InputLink, { text: intl.formatMessage({ id: "forgotYourPassword" }), href: forgotPasswordUrl }), _jsx(AuthButton, { disabled: loading, loading: loading, text: intl.formatMessage({ id: "signIn" }) })] })), _jsx(AuthFormSignInTotp, { loading: totpLoading, showModal: showTotpModal, cancelTotp: cancelTotp, onSubmit: handleSubmitTotp(function () { return setTotpLoading(true); }), formError: totpFormError, register: registerTotp, showSessionExpiredModal: showSessionExpiredModal, closeSessionExpiredModal: function () { return setShowSessionExpiredModal(false); }, errors: errorsTotp })] }));
};
export default AuthFormSignIn;
